import apiHelper, { ApiResponseType } from "./apiHelper";
import axios from "axios";
import { AUTH_TOKEN, FIRM_PATH, IS_DEMO } from "../../constants/storageKeys";
import appHelpers from "../../common/helpers/appHelpers";
import { isLogoAppProject } from "../helpers/globalHelpers";
import { create } from "apisauce";
import { publicRoutes } from "../../routes";

export const baseApiUrl = process.env.REACT_APP_BASE_URL;
const baseUrl = process.env.REACT_APP_BASE_URL + "/api/v1";
const api = create({
  baseURL: baseUrl,
})

const commonNetwork = {

  get: async function (method: string, params?: any): Promise<ApiResponseType> {
    const authToken = localStorage.getItem(AUTH_TOKEN);

    var queryString = "";
    if (params) {
      queryString = "/?" + apiHelper.objToQueryString({ obj: params });
    }
    const response = await api.get(method, params, {
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    });
    if (response.ok) {
      return apiHelper.apiSuccess({ result: response });
    } else {
      const isTokenCheck = await this.checkToken();
      if (!isTokenCheck && method != "/token/checkToken") {
        var createResult = await this.createToken();

        if (createResult) {

          return this.get(method, params);
        }
      }

      return apiHelper.apiError({ errorMsg: response.data });
    }
  },
  downloadFileGetRequest: async function (method: string, params?: any): Promise<ApiResponseType> {
    const authToken = localStorage.getItem(AUTH_TOKEN);

    var queryString = "";
    if (params) {
      queryString = "/?" + apiHelper.objToQueryString({ obj: params });
    }
    const response = await api.get(method, params, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    });
    if (response.ok) {
      return apiHelper.apiSuccess({ result: response });
    } else {
      const isTokenCheck = await this.checkToken();
      if (!isTokenCheck && method != "/token/checkToken") {
        var createResult = await this.createToken();

        if (createResult) {

          return this.get(method, params);
        }
      }

      return apiHelper.apiError({ errorMsg: response.data });
    }
  },
  post: async function (method: string, obj: any, isDocumentDownload?: boolean): Promise<ApiResponseType> {
    const authToken = localStorage.getItem(AUTH_TOKEN);

    var extraProps = {}

    if (isDocumentDownload) {
      extraProps = {
        responseType: "blob",
      }
    }

    const response = await api.post(method, obj, {
      ...extraProps,
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json; charset=utf-8",
        "Accept": "application/json"
      }
    });

    if (isDocumentDownload) {
      return {
        data: response.data,
        isSuccess: true,
        errorMessage: ""
      };
    }

    if (response.ok) {
      return apiHelper.apiSuccess({
        result: response
      });
    } else {
      const isTokenCheck = await this.checkToken();

      if (!isTokenCheck) {
        var createResult = await this.createToken();

        if (createResult) {

          return this.post(method, obj);
        }
      }
      return apiHelper.apiError({ errorMsg: response.data });
    }
  },
  put: async function (method: string, obj: any): Promise<ApiResponseType> {
    const authToken = localStorage.getItem(AUTH_TOKEN);

    const response = await api.put(method, obj, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json; charset=utf-8",
        "Accept": "application/json"
      }
    });

    if (response.ok) {
      return apiHelper.apiSuccess({
        result: response
      });
    } else {
      const isTokenCheck = await this.checkToken();

      if (!isTokenCheck) {
        var createResult = await this.createToken();

        if (createResult) {

          return this.post(method, obj);
        }
      }
      return apiHelper.apiError({ errorMsg: response.data });
    }
  },
  delete: async function (method: string, params?: any): Promise<ApiResponseType> {
    const authToken = localStorage.getItem(AUTH_TOKEN);

    var queryString = "";
    if (params) {
      queryString = "/?" + apiHelper.objToQueryString({ obj: params });
    }
    const response = await api.delete(method, params, {
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    });
    if (response.ok) {
      return apiHelper.apiSuccess({ result: response });
    } else {
      const isTokenCheck = await this.checkToken();
      if (!isTokenCheck && method != "/token/checkToken") {
        var createResult = await this.createToken();

        if (createResult) {

          return this.get(method, params);
        }
      }

      return apiHelper.apiError({ errorMsg: response.data });
    }
  },
  postFormData: async function (method: any, params: any) {
    const authToken = localStorage.getItem(AUTH_TOKEN);
 
  
    try {
      const response =  await api.post(method, params, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.ok) {
        return apiHelper.apiSuccess({
          result: response
        });
      } else {
        const isTokenCheck = await this.checkToken();
  
        if (!isTokenCheck) {
          var createResult = await this.createToken();
  
          if (createResult) {
  
            return this.post(method, params);
          }
        }
        return apiHelper.apiError({ errorMsg: response.data });
      }
    } catch (error) {
      return apiHelper.apiError({
        errorMsg: error,
      })
    }
  },
  createToken: async function () {
    const platform = appHelpers.getPlatform();
    if (platform == "web") {
      return false;
    }
    const client_id = process.env.REACT_APP_CLIENT_ID;
    const client_secret = process.env.REACT_APP_CLIENT_SECRET;
    var params = {
      ClientId: client_id,
      ClientSecret: client_secret,
      TaxNumber: appHelpers.getTaxNumber(),
      LicenceKey: appHelpers.getLicenceKey()
    }

    const apiUrl = baseUrl;
    var retrunVal = false;
    try {
      var tokenresult = await axios.post(apiUrl + `/token`, params);
      if (tokenresult.data.isSuccess) {
        const { data } = tokenresult.data;
        const { access_token, is_demo } = data;
        localStorage.setItem(AUTH_TOKEN, access_token);
        localStorage.setItem(IS_DEMO, is_demo);
        return true;
      } else {
        const { data } = tokenresult.data;
        localStorage.setItem(IS_DEMO, "false");
        if (data != null) {
          const { firmnotavailable } = data;
          if (firmnotavailable) {
            ///Yeni oluşturulacak mı diye kontrol et
            var firmInfo = appHelpers.getForCreateFirm();
            var firmResult = await axios.post(apiUrl + `/token/createFirmIfPackage`, firmInfo);
            const { data } = firmResult;
            if (data && data.isSuccess) {
              const { access_token, is_demo } = data;
              localStorage.setItem(AUTH_TOKEN, access_token);
              localStorage.setItem(IS_DEMO, is_demo);
              window.location.reload();
              retrunVal = true;
            }

          }
        }
      }
    } catch (error) {
    }

    return retrunVal;

  },


  checkToken: async function (passClear?: boolean) {
    const apiUrl = baseUrl;
    const authToken = localStorage.getItem(AUTH_TOKEN);


    const url = apiUrl + "/token/checkToken";

    try {
      await axios.get(url, {
        headers: { Authorization: `Bearer ${authToken}` }
      });
      return true;
    } catch (error) {

      var isLogoApp = isLogoAppProject();
      if (!isLogoApp && passClear != true) {
        var currentUrl = window.location.href;
        var index = publicRoutes.findIndex(w => currentUrl.indexOf(w.path || "") != -1);
        if (index == -1) {

          this.clearLocalStorage();
          window.location.reload();
        }

      }
      return false;
    }
  },
  clearLocalStorage() {

    for (let i = 0; i < localStorage.length; i++) {

      let key = localStorage.key(i) || "";
      if (key != FIRM_PATH) {
        localStorage.removeItem(key);
      }
    }

  },
  postUrl: async function (url: string, obj: any) {

    const response = await axios
      .post(url, obj, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json; charset=utf-8"
        },
      })
      .then((res) => apiHelper.apiSuccess({ result: res }))
      .catch((err) => {

        return apiHelper.apiError({ errorMsg: err });
      });
    return response;
  },
  extractErrorMessage(error: any) {

    if (error.response && error.response.data && error.response.data.length > 0) {
      var serverMessage = error.response.data;
      if (serverMessage.indexOf("Login Required") != -1) {


        return true;
      } else return false;

    } else {
      return false;
    }

  }
}

export default commonNetwork;